import { atom } from 'jotai';
import type { ExamItemAnswerAiCorrectionViewModel } from '@/shared/api/generated/types';

/**
 * Sugestões de correção por IA obtidas em lote (`ai-correction-batch`), indexadas
 * por `answerId`.
 *
 * Estado client-side efêmero — não persiste após recarregar a página e não é
 * gravado no backend. Nunca use `useAtom` diretamente em componentes; use
 * `useAiBatchSuggestions`.
 */
export const aiBatchSuggestionsAtom = atom<
  Readonly<Record<number, ExamItemAnswerAiCorrectionViewModel>>
>({});
aiBatchSuggestionsAtom.debugLabel = 'exam-correction/aiBatchSuggestionsAtom';
